import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';

import { IReportsActions, IThunkGetCrisisReport } from '../types';

const onGetCrisisReport: IThunkGetCrisisReport = thunk(
  async ({ setCrisisReport }: Actions<IReportsActions>, props) => {
    const data = await api.reports
      .getCrisisReport(props.payload, props.params, props.signal)
      .then(r => r.data);

    setCrisisReport({
      list: data.items,
      pagination: {
        total: data.total,
        pageNumber: props.params.pageNumber,
        pageSize: props.params.pageSize,
      },
    });
  },
);

export default onGetCrisisReport;
